import { Div, Button } from '@codesuma/baseline'
import style from './index.module.css'

// The progress dots and the buttons, pinned under the sliding steps so they
// never move. One row, as in noush: the way on takes the width and the colour,
// and Back or the shortcut that creates the list before the last step sits
// beside it at its own size. Emits 'next', 'prev' and 'done'. Ported from
// emrouz's wizard.

export interface INavState {
    steps: number
    index: number
    nextLabel: string
    nextEnabled: boolean
    showPrev: boolean
    showDone: boolean
}

export const WizardNav = () => {
    const base = Div()
    base.addClass(style.nav)

    const dots = Div()
    dots.addClass(style.dots)

    const buttons = Div()
    buttons.addClass(style.navButtons)

    const prev = Button('Back')
    prev.addClass(style.secondaryBtn)
    prev.on('click', () => base.emit('prev'))

    // Firmer edge than Back: this one writes something, Back doesn't.
    const done = Button('Save')
    done.addClass(style.secondaryBtn, style.doneBtn)
    done.on('click', () => base.emit('done'))

    const next = Button()
    next.addClass(style.primaryBtn)
    next.on('click', () => base.emit('next'))

    buttons.append(prev, done, next)
    base.append(dots, buttons)

    const setState = ({ steps, index, nextLabel, nextEnabled, showPrev, showDone }: INavState) => {
        dots.empty()
        for (let i = 0; i < steps; i++) {
            const dot = Div()
            dot.addClass(style.dot)
            dot.toggleClass(style.dotActive, i === index)
            dots.append(dot)
        }

        next.text(nextLabel)
        next.el.disabled = !nextEnabled
        // Both wait for the same thing, a name, so neither moves when it comes.
        done.el.disabled = !nextEnabled

        prev.style({ display: showPrev ? '' : 'none' })
        done.style({ display: showDone ? '' : 'none' })
    }

    return Object.assign(base, { setState })
}
